"use client";

import { css } from "@/../styled-system/css";

import FooterCopyright from "./FooterCopyright";
import FooterLinks from "./FooterLinks";
import FooterNewsletter from "./FooterNewsletter";

const footerClass = css({
  backgroundColor: "brandBlack",
  width: "90%",
  maxWidth: "1280px",
  m: "auto",
  pt: "16",
  pb: "12",
});

function Footer() {
  return (
    <footer
      className={css({
        backgroundColor: "brandBlack",
        width: "100%",
        mt: "auto",
      })}
    >
      <div className={footerClass}>
        <div className={css({ mb: "8", md: { mb: "16" } })}>
          <FooterNewsletter />
        </div>
        <hr
          className={css({ color: "brandBlue/10", mb: "8", md: { mb: "16" } })}
        />
        <div className={css({ mb: "8", md: { mb: "16" } })}>
          <FooterLinks />
        </div>
        <div>
          <FooterCopyright />
        </div>
      </div>
    </footer>
  );
}

export default Footer;
